import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApiDeviceResponseDto } from '@birco/rainmesh-api';
import { TextWithIconComponent } from "../../../../shared/components/text-with-icon/text-with-icon.component";
import { IconComponent } from "../../../../shared/icons/icon.component";
import { TagComponent } from "../../../../shared/components/tag/tag.component";
import { IconsPipe } from "../../../../shared/pipes/icons.pipe";
import { TranslatePipe } from '@ngx-translate/core';
import { PowerItemComponent } from "../../../devices/components/power-item/power-item.component";
import { RouteConstants } from '../../../../shared/constants/route-constants';
import { RouterLink } from '@angular/router';
import { isDeviceActive } from '../../../devices/utils/device-value.utils';
import { LocalizedNumberPipe } from "../../../../shared/pipes/localized-number.pipe";
import { RelativeDatePipe } from "../../../../shared/pipes/relative-date.pipe";
import { LabelConverter } from '../../../../shared/converter/label.converter';
import { DeviceActionTriggerComponent } from "../../../devices/components/device-action-trigger/device-action-trigger.component";
import { CardComponent } from "../../../../shared/components/card/card.component";
import { getDeviceDetailRoute } from '../../../../shared/utils/device-route.util';

@Component({
  selector: 'app-map-device-detail',
  imports: [TextWithIconComponent, IconComponent, TagComponent, IconsPipe, TranslatePipe, PowerItemComponent, RouterLink, LocalizedNumberPipe, RelativeDatePipe, DeviceActionTriggerComponent, CardComponent],
  templateUrl: './map-device-detail.component.html',
  styleUrl: './map-device-detail.component.scss'
})
export class MapDeviceDetailComponent {

  @Input() device: ApiDeviceResponseDto | null = null;
  @Output() closeDetail = new EventEmitter<{ id: string }>();
  @Output() triggerDeviceAction = new EventEmitter<{ id: string, value: boolean }>();

  get isActive() {
    return !!this.device?.isActuator && isDeviceActive(this.device)
  }

  get isInteractionDisabled() {
    return this.device?.isOutOfService === true;
  }

  onTriggerDeviceAction(value: boolean) {
    if (!this.device?.isActuator || this.isInteractionDisabled) return
    this.triggerDeviceAction.emit({
      id: this.device.id,
      value: value,
    })
  }

  protected readonly RouteConstants = RouteConstants;
  protected readonly LabelConverter = LabelConverter;
  protected readonly getDeviceDetailRoute = getDeviceDetailRoute;
}
